export var EnvironmentTypes;
(function (EnvironmentTypes) {
    EnvironmentTypes["DEVELOPMENT"] = "development";
    EnvironmentTypes["STAGING"] = "staging";
    EnvironmentTypes["ONBOARDING"] = "onboarding";
    EnvironmentTypes["PRODUCTION"] = "production";
    EnvironmentTypes["LOCAL"] = "local";
})(EnvironmentTypes || (EnvironmentTypes = {}));
export var ApiResponseCodes;
(function (ApiResponseCodes) {
    ApiResponseCodes[ApiResponseCodes["unauthorized"] = 403] = "unauthorized";
})(ApiResponseCodes || (ApiResponseCodes = {}));
export var Region;
(function (Region) {
    Region["DEU"] = "deu";
    Region["GBR"] = "gbr";
})(Region || (Region = {}));
//# sourceMappingURL=domain.js.map